import type { ModalProps } from "../../utils";
import styles from "./ErrorNotify.module.scss";

const ErrorNotify: React.FC<ModalProps> = ({ onClose }) => {
	return (
		<div className={styles.content}>
			<div className={styles.text}>
				<h2>Ошибка!</h2>
				<span>Что-то пошло не так. Попробуйте ещё раз.</span>
			</div>
			<button className={styles.button} type="button" onClick={onClose}>
				Попробовать еще раз
			</button>
		</div>
	);
};

export default ErrorNotify;
